module.exports = __webpack_public_path__ + "img/About-Nature-dwnszd.bfc22fa7.jpg";